import { Modal } from 'antd';
import React, { useMemo } from 'react';
import { t } from '../../../../locales';

import vadd from '../../../../assets/vadd.svg';
import vexport from '../../../../assets/vexport.svg';
import vscene from '../../../../assets/vscene.svg';
import vtime from '../../../../assets/vtime.svg';
import vuser from '../../../../assets/vuser.svg';

import './index.scss';

type Props = {
  showModal: boolean,
  setShowSyncModal: (show: boolean) => void;
}
const OpenVip = (props: Props) => {
  const { showModal, setShowSyncModal } = props;

  return (
    <Modal
      title={t('vip.lockTitle')}
      open={showModal}
      onCancel={() => setShowSyncModal(false)}
      footer={null}
      width={456}
      centered
    >
      <div className='open-vip'>
        <div className='open-vip-list'>
          <div className='open-vip-list-item'>
            <img src={vtime} alt="" />
            <span>{t('vip.lockRights1')}</span>
          </div>
          <div className='open-vip-list-item'>
            <img src={vscene} alt="" />
            <span>{t('vip.lockRights2')}</span>
          </div>
          <div className='open-vip-list-item'>
            <img src={vuser} alt="" />
            <span>{t('vip.lockRights3')}</span>
          </div>
          <div className='open-vip-list-item'>
            <img src={vadd} alt="" />
            <span>{t('vip.lockRights4')}</span>
          </div>
          <div className='open-vip-list-item'>
            <img src={vexport} alt="" />
            <span>{t('vip.lockRights5')}</span>
            <span></span>
          </div>
        </div>
        <div className='open-vip-tip'>
          {t('vip.lockSubTitle')}
        </div>
      </div>
    </Modal>
  )
}

export default OpenVip;